module.exports = __webpack_public_path__ + "img/kx2.9d8ae260.png";